export default {
      id: "i-info-advantages-01-usage",
      viewBox: "0 0 40 38",
      url: __webpack_public_path__ + "img/sprite.svg#i-info-advantages-01",
      toString: function () {
        return this.url;
      }
    }